import React, { Component } from "react";
import './Information.css';
import { MDBRow, MDBCol } from "mdbreact";

class CardsRecomendaciones extends Component {
    render() {
        return (
            <div className="container">
                <div className="spacer-50 mb-4"></div>
                <MDBRow>
                    <MDBCol>
                        <div className="lih-1">
                            <h1 className="title-recomendaciones wow animated zoomInDown fz-r">
                                RECOMENDACIONES
                            </h1>
                            <p className="title-section font-weight-bold wow animated zoomInDown delay-1 text-uppercase">Envío DE TUS DOCUMENTOS</p>
                        </div>
                    </MDBCol>
                </MDBRow>
                <MDBRow className="justify-content-center">
                    <MDBCol className="col-md-9">
                        <div className="listaOl p-5 p-md-3 wow animate fadeInRight delay-1s">
                            <ul className="colorEtiqueta inform-list">
                                <li><span>1.</span><p>Envía tus documentos escaneados en formatos (PDF, JPG, PNG).</p></li>
                                <li><span>2.</span><p>Asegúrate que tus archivos tengan óptima calidad.</p></li>
                                <li><span>3.</span><p>Coloca el nombre que corresponde a cada uno de tus archivos.</p></li>
                                <li><span>4.</span><p>Ten en cuenta que, al momento de escanear, el documento deberá de estar en posición vertical u horizontal, según corresponda.</p></li>
                                <li><span>5.</span><p>Asegúrate que el documento se visualice completamente y <b>no tenga ningún recorte</b> donde omita información importante.</p></li>
                                <li><span>6.</span><p>Verifica que tus documentos tengan un tamaño inferior a 4 MB.</p></li>
                            </ul>
                        </div>
                    </MDBCol>
                </MDBRow>
            </div>
        );
    }
}
export default CardsRecomendaciones;